// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z2Y2","rootNoMargin":"styles_rootNoMargin__vF9hL"};